import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequest, filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { Epic, EpicRefined } from 'interfaces/middleware'
import { mergeMap, map } from 'rxjs/operators'
import {
  CCOnboardingActions,
  PatchCCOnboardingAddressAction,
  PatchCCOnboardingPropsAction,
  PatchCCOnboardingSSNAction,
} from 'components/features/creditCard/creditCardStore/actions'
import { CC_ONBOARDING_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import { of, merge, EMPTY } from 'rxjs'
import { startSubmit, stopSubmit } from 'redux-form'
import { CC_ONBOARDING_FORM_ADDRESS, CC_ONBOARDING_FORM_SSN } from 'components/features/creditCard/creditCardOnboarding/constants'
import { byType } from 'rxOperators/byType'
import { pushActionCreator } from 'actions/navigationActions'
import { getResponseFormErrors } from 'helpers/ajaxHelpers'

export const patchCCOnboardingPropsEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$, _, { patch }) => action$.pipe(
  filterRequest(PatchCCOnboardingPropsAction.type),
  mergeMap((action) => patch(CC_ONBOARDING_URL, { body: action.payload.params }).pipe(
    map(({ response }) => action.success(response)),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response }))),
  )),
)

export const patchCCOnboardingPropsSuccessEpic: Epic = (action$) => action$.pipe(
  filterRequestOfType(PatchCCOnboardingPropsAction.type, 'success'),
  mergeMap((action) => of(pushActionCreator(`/credit-card/onboarding/${ action.payload.response.step }`)))
)

export const patchCCOnboardingAddressEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$) => action$.pipe(
  byType(PatchCCOnboardingAddressAction.type),
  mergeMap((action) => {

    const response$ = action$.pipe(
      filterRequestOfType(PatchCCOnboardingPropsAction.type, 'success'),
      mergeMap(() => of(stopSubmit(CC_ONBOARDING_FORM_ADDRESS))),
    )

    const fail$ = action$.pipe(
      filterRequestOfType(PatchCCOnboardingPropsAction.type, 'fail'),
      mergeMap((patchFailAction) => {
        const { person_data, ...restErrors } = patchFailAction.payload.errorsMap || {} as any
        const addressErrors = person_data?.address || {}

        const {
          city_id,
          zip5,
          number: bldNumber,
          street,
          refinement,
        } = addressErrors || {}

        const {
          non_field_errors,
        } = restErrors || {}

        const errMap = {
          ...(bldNumber || street) ? { address1: bldNumber || street } : {},
          ...(refinement) ? { address2: refinement } : {},
          ...(zip5) ? { zip5 } : {},
          ...(city_id) ? { city: city_id } : {},
          ...(non_field_errors) ? { non_field_errors } : {},
        }

        const errRes = getResponseFormErrors(errMap)

        if (Object.keys(errRes).length === 0) {
          return EMPTY
        }
        return of(stopSubmit(CC_ONBOARDING_FORM_ADDRESS, errRes))
      })
    )

    return merge(
      of(startSubmit(CC_ONBOARDING_FORM_ADDRESS)),
      of(new PatchCCOnboardingPropsAction(action.payload)),
      response$,
      fail$,
    )
  })
)

export const patchCCOnboardingSSNEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$) => action$.pipe(
  byType(PatchCCOnboardingSSNAction.type),
  mergeMap((action) => {
    const response$ = action$.pipe(
      filterRequestOfType(PatchCCOnboardingPropsAction.type, 'success'),
      mergeMap(() => of(stopSubmit(CC_ONBOARDING_FORM_SSN))),
    )

    const fail$ = action$.pipe(
      filterRequestOfType(PatchCCOnboardingPropsAction.type, 'fail'),
      mergeMap((patchFailAction) => {
        const { person_data, ...restErrors } = patchFailAction.payload.errorsMap || {} as any

        const errRes = getResponseFormErrors({
          ...restErrors,
          ...(person_data || {}),
        })

        if (Object.keys(errRes).length === 0) {
          return EMPTY
        }
        return of(stopSubmit(CC_ONBOARDING_FORM_SSN, errRes))
      })
    )

    return merge(
      of(startSubmit(CC_ONBOARDING_FORM_SSN)),
      of(new PatchCCOnboardingPropsAction(action.payload)),
      response$,
      fail$,
    )
  })
)
